import { Text } from '@music-vine/cadence/ui';
import { Layers } from '@music-vine/cadence/icons';
import { CustomLicensingFormTrigger } from './CustomLicensingFormTrigger';

/** Custom licensing enquiry banner + Typeform dialog (DEV-6398). */
export const CustomPackageBanner = () => <div className="flex flex-col items-start justify-between gap-4 rounded-xl border border-blue-business-200 border-solid bg-blue-business-25 p-6 sm:flex-row sm:items-center dark:border-blue-business-925 dark:bg-blue-business-975" data-sentry-component="CustomPackageBanner" data-sentry-source-file="CustomPackageBanner.tsx">
    <div className="flex items-center gap-2.5">
      <div className="flex size-12 items-center justify-center rounded-sm bg-blue-500 p-3">
        <Layers className="size-6 text-white" data-sentry-element="Layers" data-sentry-source-file="CustomPackageBanner.tsx" />
      </div>
      <div>
        <Text asChild className="mb-0.5 flex items-center gap-1 font-semibold text-gray-950 text-xl dark:text-white" data-sentry-element="Text" data-sentry-source-file="CustomPackageBanner.tsx">
          <h3>Need broader rights?</h3>
        </Text>
        <Text className="text-gray-700 text-sm dark:text-gray-400" data-sentry-element="Text" data-sentry-source-file="CustomPackageBanner.tsx">
          Talk to us about custom licensing options for broadcast, streaming
          services, radio, cinema and more.
        </Text>
      </div>
    </div>
    <CustomLicensingFormTrigger content="Talk to us" eventValue="pricing-page-custom-package" type="button" data-sentry-element="CustomLicensingFormTrigger" data-sentry-source-file="CustomPackageBanner.tsx" />
  </div>;